<template>
  <div class="flex align-center wrap w-full bg-white main">

    <SmartButton
      secondary
      @click="displayChannel = !displayChannel"

      class="mr-1">Canal
    </SmartButton>

    <div class="auxChannel" v-if="displayChannel" v-on-clickaway="awayChannel">
      <div class="canal">
        <label>Canal</label>
        <v-select
          :loading="true"
          :items="channels"
          @change="getChannels"
          v-model="selectedChannel"
        >
          <template v-slot:item="{ item, index }">
            <span :id="`item-${index}`">{{ item.name }}</span>
          </template>
          <template v-slot:selection="{ item, index }">
            <span :id="`item-selection-${index}`">{{ item.name }}</span>
          </template>
        </v-select>
        <div class="btn mt-1 flex justify-end">
          <button class="btn button" @click="displayChannel = false">
            Cancelar
          </button>
          <button class="btn button">
            <p class="text-ui-accent" @click="closeModalChannel">Aplicar</p>
          </button>
        </div>
      </div>
    </div>

    <SmartButton
      @click="display = true"
      secondary
      class="mr-1">
      Regional
    </SmartButton>

    <div class="aux" v-if="display" v-on-clickaway="away">
      <div class="visao">
        <label>Visão</label>
        <v-select
          :items="regional"
          v-model="selectedView"
        >
          <template v-slot:item="{ item, index }">
            <span :id="`item-${index}`">{{ item }}</span>
          </template>
          <template v-slot:selection="{ item, index }">
            <span :id="`item-selection-${index}`">{{ item }}</span>
          </template>
        </v-select>
      </div>

      <div class="regional mt-2">
        <label>Regional</label>
        <v-select
          :items="visit"
          v-model="regional"
        >
          <template v-slot:item="{ item, index }">
            <span :id="`item-${index}`">{{ item.slug }}</span>
          </template>
          <template v-slot:selection="{ item, index }">
            <span :id="`item-${index}`">{{ item.slug }}</span>
          </template>
        </v-select>
      </div>
      <div class="btn mt-2 flex justify-end">
        <button class="btn button" @click="display = false">
          Cancelar
        </button>
        <button class="btn button" @click="getVisits">
          <p class="text-ui-accent" @click="display = false">Aplicar</p>
        </button>
      </div>
    </div>

    <SmartInput
      placeholder="Data inicial"
      v-model="data_from"
      type="date-picker"
      name="Data Inicial"
      @change="getVisits"
    />

    <SmartInput
      v-model="data_to"
      type="date-picker"
      name="Data final"
      @change="getVisits"
    />

  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { formatUSDate } from 'utils';
import { mixin as clickaway } from 'vue-clickaway';
import api from 'tim-api';
import { channels as channelsEndPoint, view as viewsEndPoint } from 'endPoints';

// @flow
export default {
  mixins: [clickaway],
  data() {
    return {
      data_from: '',
      data_to: '',
      cust_code: '',
      regional: '',
      display: false,
      channels: [],
      displayChannel: false,
      selectedChannel: [],
      selectedView: []
    };
  },
  props: {
    visit: {
      type: Array,
      default: () => {}
    }
  },

  methods: {
    ...mapActions({
      fetchVisits: 'visit/fetchVisits'
    }),

    getChannels() {
      api.get(channelsEndPoint).then((data) => {
        const struct = data.data.data;

        this.channels = struct.map(item => ({
          name: item.name,
          id: item.id
        }));
      });
    },

    getViews() {
      api.get(viewsEndPoint).then((data) => {
        this.regional = data.data.data;
      });
    },

    away() {
      this.display = false;
    },

    awayChannel() {
      this.displayChannel = false;
    },

    changeStyle() {
      this.display = true;
    },

    changeStyleChannel() {
      this.displayChannel = true;
    },

    getVisits() {
      this.fetchVisits({
        from: formatUSDate(this.data_from),
        to: formatUSDate(this.data_to),
        cust_code: this.cust_code,
        regional: this.regional,
        channels: this.channels
      });
    },

    closeModalChannel() {
      this.displayChannel = false;
    }
  },

  async mounted() {
    await this.getChannels();
    await this.getViews();
  }

};
</script>

<style lang="scss" scoped>

.main {
  background-color: #fafafa;
}
.aux , .auxChannel {
  position: absolute;
  top: 45px;
  background-color: white;
  z-index: 1;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 20px;
}

.aux {left: 100px}
.auxChannel {left: 0px}

.btn button{
  border: none;
  font-size: 14px;
  cursor: pointer;
}
</style>
